.root {
  font-style: normal;
}

.left {
  text-align: left;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

@each $size, $value in $font-sizes {
  .size-#{$size} {
    @include font-size($size);
  }
}

@each $weight, $value in $font-weight {
  .#{$weight} {
    @include font-weight($weight);
  }
}
